// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1M0mC","buttons":"SendReceipts_buttons__2OdBt","email":"SendReceipts_email__2u6sk","bookApptTitle":"SendReceipts_bookApptTitle__3QsAc"};